<!-- ? V2 1XP -->
<template>
  <figure :class="$style.container">
    <div :class="$style.content">
      <img v-if="image" :alt="`${firstname} ${lastname}`" :class="$style.image" :src="image" />
      <div :class="$style.upperSection">
        <div v-if="country" :class="$style.location">
          <Icon name="location_on" size="small" />
          {{ country }}
        </div>
        <section
          v-if="head || company || name || (firstname && lastname) || description || position"
          :class="$style.head"
        >
          <div v-if="head" :class="$style.title">
            {{ head }}
          </div>
          <div v-if="company" :class="$style.title">
            {{ company }}
          </div>
          <div v-if="firstname && lastname" :class="$style.title">
            {{ firstname }} {{ lastname }}
          </div>
          <div v-if="name">
            {{ name }}
          </div>
          <div v-if="description">
            {{ description }}
          </div>
          <div v-if="position" v-html="position" />
        </section>
        <section v-if="address || street || city || country" :class="$style.address">
          <div v-if="address" v-html="`${address.replace(/(?:\r\n|\r|\n)/g, '<br>')}`" />
          <div v-if="street">
            {{ street }}
          </div>
          <div v-if="city">
            {{ city }}
          </div>
          <div v-if="country">
            {{ country }}
          </div>
        </section>
      </div>
      <div :class="$style.divider" />
      <section
        v-if="phone || mobile || fax || website || email || vcard || useForm || fromEmail"
        :class="$style.contact"
      >
        <Button1XP
          v-if="phone"
          start-icon="call"
          :text="phone"
          :url="`tel:${phone}`"
          variant="linkStatic"
        />
        <Button1XP
          v-if="mobile"
          start-icon="mobile_2"
          :text="mobile"
          :url="`tel:${mobile}`"
          variant="linkStatic"
        />
        <Button1XP v-if="fax" start-icon="fax" :text="fax" variant="linkStatic" />
        <Button1XP
          v-if="website"
          start-icon="language"
          target="blank"
          :text="websiteText.trim() !== '' ? websiteText : website"
          :url="website"
          variant="linkStatic"
        />
        <Button1XP
          v-if="email"
          start-icon="mail"
          :text="email"
          :url="`mailto:${email}`"
          variant="linkStatic"
        />
        <Button1XP
          v-if="useForm && contactFormUrl"
          size="xs"
          start-icon="email"
          :text="storeTranslations.translations?.['dynamicForm']"
          :url="contactFormUrl"
          variant="linkStatic"
        />
        <Button1XP
          v-if="vcard"
          start-icon="download"
          text="vCard"
          :url="vcard"
          variant="linkStatic"
        />
      </section>
    </div>
  </figure>
</template>

<script setup>
import { useStoreTranslations } from '../../store/translations/translations';
import Button1XP from '../Button1XP/Button1XP.vue';
import Icon from '../Icon/Icon.vue';

defineProps({
  id: {
    type: Number,
    default: undefined,
  },
  image: {
    type: String,
    default: '',
  },
  head: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  position: {
    type: String,
    default: '',
  },
  company: {
    type: String,
    default: '',
  },
  address: {
    type: String,
    default: '',
  },
  street: {
    type: String,
    default: '',
  },
  city: {
    type: String,
    default: '',
  },
  country: {
    type: String,
    default: '',
  },
  firstname: {
    type: String,
    default: '',
  },
  lastname: {
    type: String,
    default: '',
  },
  fromEmail: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    default: '',
  },
  phone: {
    type: String,
    default: '',
  },
  fax: {
    type: String,
    default: '',
  },
  mobile: {
    type: String,
    default: '',
  },
  website: {
    type: String,
    default: '',
  },
  websiteText: {
    type: String,
    default: '',
  },
  email: {
    type: String,
    default: '',
  },
  formEmail: {
    type: String,
    default: '',
  },
  vcard: {
    type: String,
    default: '',
  },
  additionalText: {
    type: String,
    default: '',
  },
  contactFormUrl: {
    type: String,
    default: '',
  },
  useForm: {
    type: Boolean,
    default: false,
  },
});

const storeTranslations = useStoreTranslations();
</script>

<style module lang="scss">
@forward './ContactBox.scss';
</style>
